import { createBrowserRouter, Navigate } from "react-router-dom";

import { RequireAuth } from "@app/auth/RequireAuth";
import AppLayout from "@app/layout/AppLayout";
import LoginPage from "@app/pages/LoginPage";
import OverviewPage from "@app/pages/OverviewPage";
import ActivityPage from "@app/pages/ActivityPage";
import UsersPage from "@app/pages/UsersPage";
import UserDetailPage from "@app/pages/UserDetailPage";
import OrganizationsPage from "@app/pages/OrganizationsPage";
import OrganizationDetailPage from "@app/pages/OrganizationDetailPage";
import GamesPage from "@app/pages/GamesPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <OverviewPage /> },
      { path: "activity", element: <ActivityPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "users/:id", element: <UserDetailPage /> },
      { path: "organizations", element: <OrganizationsPage /> },
      { path: "organizations/:id", element: <OrganizationDetailPage /> },
      { path: "games", element: <GamesPage /> }
    ]
  },
  { path: "*", element: <Navigate to="/" replace /> }
]);
